// extracted by mini-css-extract-plugin
module.exports = {"feature":"Feature_feature__1ibzk","flier":"Feature_flier__1bBtO"};